import type { MainMenuConfig } from '@szte-griffin/feature/app-layout/ui';
import type { AdminUserRole } from '@cappus/sdk-mecap-backend';

function addPrefix(item: string): string {
  return `MENU.${item}`;
}

export const MAIN_MENU_CONFIG: MainMenuConfig<AdminUserRole> = {
  items: [
    {
      label: addPrefix('ADMIN_USER'),
      routeLink: '/admin-user',
      icon: 'pct-mdi-account-multiple',
      role: 'SystemAdmin',
      name: 'admin-user',
    },
    {
      label: addPrefix('NEWS'),
      routeLink: '/news',
      icon: 'pct-mdi-newspaper',
      role: ['SystemAdmin', 'Admin'],
      name: 'news',
    },
    {
      label: addPrefix('EVENT'),
      routeLink: '/event',
      icon: 'pct-mdi-calendar',
      role: ['SystemAdmin', 'Admin'],
      name: 'event',
    },
    {
      label: addPrefix('OFFER'),
      routeLink: '/offer',
      icon: 'pct-mdi-sale',
      role: ['SystemAdmin', 'Admin'],
      name: 'offer',
    },
    {
      label: addPrefix('LOCATION'),
      routeLink: '/location',
      icon: 'pct-mdi-map',
      role: ['SystemAdmin', 'Admin'],
      name: 'location',
    },
    {
      label: addPrefix('POI'),
      routeLink: '/poi',
      icon: 'pct-mdi-map-marker-multiple',
      role: ['SystemAdmin', 'Admin'],
      name: 'poi',
    },
    {
      label: addPrefix('RESOURCE'),
      routeLink: '/resource',
      icon: 'pct-mdi-calendar-clock',
      role: ['SystemAdmin', 'Admin'],
      name: 'resource',
    },
    {
      label: addPrefix('NOTIFICATIONS'),
      routeLink: '/notification',
      icon: 'pct-mdi-bell',
      role: ['SystemAdmin', 'Admin'],
      name: 'notifications',
    },
    {
      label: addPrefix('FORBIDDEN_NICKNAME'),
      routeLink: '/forbidden-nickname',
      icon: 'pct-mdi-cancel',
      role: ['SystemAdmin', 'Admin'],
      name: 'forbidden-nickname',
    },
    {
      label: addPrefix('ONBOARDING_STEP'),
      routeLink: '/onboarding-step',
      icon: 'pct-mdi-cellphone-information',
      role: ['SystemAdmin', 'Admin'],
      name: 'onboarding-step',
    },
  ],
};
